import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AppointmentService} from "../../../../../../feature-crm/as/service/api/appointment.service";
import {AppointmentStatusInternal} from "../../../../../../feature-crm/as/enum/appointment-status-internal.enum";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {QlJoinDto} from "../../../../../../core/shared/ql/data/dto/ql-join.dto";


@Component({
    selector: 'mvs-example',
    templateUrl: 'agent-statistics.component.html',
    standalone: false
})
export class AgentStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    appointmentCompleted: number = 0;
    pendingAppointment: number = 0;
    scheduledAppointment: number = 0;
    cancelledAppointment: number = 0;

    overviewDto: OverviewDto[];

    appointmentsPerMonthWidget: WidgetData;
    agentCategoryByAgentPoolWidget: WidgetData;
    appointmentTypeWidget: WidgetData;
    recentlyJoinedAgentsWidget: WidgetData;

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected appointmentService: AppointmentService) {
        super(route, coreService)
    }

    ngOnInit(): void {

        this.items = [
            {label: 'Agent Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();


    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.getAppointmentResult();
        this.refreshAppointmentsPerMonthWidgets();
        this.refreshAgentCategoryByAgentPoolWidgets();
        this.refreshAppointmentTypeWidgets();
        this.refreshRecentlyJoinedAgents();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/am/config']);
    }


    getAppointmentResult() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['status'],
            [new ObjectRequestListAttribute('status', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.appointmentService.groupBy(objectRequestList).subscribe(res => {

            this.overviewDto = [
                { label: 'Appointment Completed', value: 0 },
                { label: 'Pending Appointments', value: 0 },
                { label: 'Scheduled Appointments', value: 0 },
                { label: 'Cancelled Appointments', value: 0 }
            ];

            for (const entry of res.entries) {
                if (entry['status'] === AppointmentStatusInternal.completed) {
                    this.overviewDto.find(item => item.label === 'Appointment Completed').value = entry['status_count'];
                } else if (entry['status'] === AppointmentStatusInternal.pending) {
                    this.overviewDto.find(item => item.label === 'Pending Appointments').value = entry['status_count'];
                } else if (entry['status'] === AppointmentStatusInternal.scheduled) {
                    this.overviewDto.find(item => item.label === 'Scheduled Appointments').value = entry['status_count'];
                } else if (entry['status'] === AppointmentStatusInternal.cancelled) {
                    this.overviewDto.find(item => item.label === 'Cancelled Appointments').value = entry['status_count'];
                }
            }



        });

    }

    refreshAppointmentsPerMonthWidgets() {
        this.appointmentsPerMonthWidget = WidgetFactory.createWidget(
            'am.agent.overview.appointments.per.month.widget',
            'Appointments Per Month',
            'history.chart',
            'list',
            'entity.groupBy',
            'as.Appointment',
            WidgetDataParam.create("fieldCategory", "appointmentType"),
            WidgetDataParam.create("fieldCategoryCount", "appointmentType_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.appointmentsPerMonthWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["appointmentType", "createdDate"],
            [new ObjectRequestListAttribute("appointmentType", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshAgentCategoryByAgentPoolWidgets() {
        this.agentCategoryByAgentPoolWidget = WidgetFactory.createWidgetGroupBy(
            'ag.agent.overview.agent.category.by.agent.pool.widget',
            'Agent Category By Agent Pool',
            'category',
            'entity.groupBy',
            'am.AgentPoolAgent',
            'agentPool',
            'agentPool_count',
            this.filterCriteria,
            'agentPool',
            'Anzahl');
    }

    refreshAppointmentTypeWidgets() {
        this.appointmentTypeWidget = WidgetFactory.createWidgetGroupBy(
            'ag.agent.overview.appointment.type.widget',
            'Appointment Types',
            'category',
            'entity.groupBy',
            'as.Appointment',
            'appointmentType',
            'appointmentType_count',
            this.filterCriteria,
            'appointmentType',
            'Anzahl');
    }

    refreshRecentlyJoinedAgents() {

        const join: QlJoinDto[] = [
            {
                joinType: "left",
                type: "entity",
                name: "user",
                as: "u",
            }
        ]

        this.recentlyJoinedAgentsWidget = WidgetFactory.createWidgetQl(
            'ag.agent.overview.recently.joined.agents',
            'Recently Joined Agents',
            'am.Agent',
            'table',
            this.filterCriteriaForQuery,
            [new Sorting('e.createdDate', false)],
            join
        );
    }



    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
